export default "__VITE_ASSET__Ct6OxoNd__"